// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { ChartZoomRendererButtons } from '../Renderers/TerceraChartZoomRenderer';
import { TerceraChartBaseActionProcessor } from './TerceraChartBaseActionProcessor';
export class TerceraChartXYActionProcessor extends TerceraChartBaseActionProcessor {
    processZoomAction(action) {
        let processed = false;
        switch (action.Details) {
            case ChartZoomRendererButtons.ZoomIn:
            case ChartZoomRendererButtons.StepZoomIn:
                this.chart.mainWindow.ZoomIn();
                processed = true;
                break;
            case ChartZoomRendererButtons.ZoomOut:
            case ChartZoomRendererButtons.StepZoomOut:
                this.chart.mainWindow.ZoomOut();
                processed = true;
                break;
            default:
                processed = super.processZoomAction(action);
        }
        return processed;
    }
}
